export default __webpack_public_path__ + "static/SFMono-Medium-26e2b78a923bee127a72d46579c432d3.ttf";